import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import Main from './Main';
import Shop from './Shop';
import Menu from './Menu';
import Tickets from './Tickets';
import Contacts from './Contacts';
import Music from './Music';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/lampabikt">
      <Menu />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/music" element={<Music />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/contacts" element={<Contacts />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
